import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import styled, {css} from 'styled-components';

export function User(props) {
  return (
    <>
<CSSuserAva/>
    </>
  )
}

const CSSuserAva = styled.div`
  width: 3em;
  height: 3em;
  background: var(--main-text-color);
  border-radius: 10em;
  @media (max-width: 991px) {
    width: 2em;
    height: 2em;
  }
`